<template>
	<svg
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<rect x="6.10352e-05" width="24" height="24" rx="3" fill="#252122" />
		<rect
			x="4.00006"
			y="10.4"
			width="16"
			height="3.2"
			rx="1"
			fill="white"
		/>
		<rect
			x="10.4001"
			y="20"
			width="16"
			height="3.2"
			rx="1"
			transform="rotate(-90 10.4001 20)"
			fill="white"
		/>
	</svg>
</template>

<script>
export default {
	name: "DicePositive",
};
</script>
